import { defineComponent } from 'vue';
export default defineComponent({
    name: 'DropdownFilter',
    emits: ['toggle', 'apply'],
    props: {
        title: {
            type: String,
            default: null,
        },
    },
});
